import React from 'react';
import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';
import ButtonBase from '../BaseButton';

const TextButton: React.FC<ButtonProps> = props => {
    const { size, before, after, className, children, ...domProps } = props;
    const classes = useStyles();
    const classNames = cn(classes.root, size && classes[size], className);

    return (
        <ButtonBase className={classNames} {...domProps}>
            {before && <div className={classes.surroundings}>{before}</div>}
            <div className={classes.text}>{children}</div>
            {after && <div className={classes.surroundings}>{after}</div>}
        </ButtonBase>
    );
};

const useStyles = makeStyles(
    ({ palette, typography }) => ({
        root: {
            ...typography.t61,
            color: palette.greys[700],
            lineHeight: 1,
            transition: 'all 300ms ease-in-out',
            display: 'flex',
            alignItems: 'center',
            maxWidth: '100%',
            paddingBottom: '.375em',
            paddingTop: '.375em',
            borderBottom: `1px solid ${palette.greys[700]}`,

            '& > * + *': {
                marginLeft: '.5em',
            },

            '&:hover': {
                color: palette.greys[600],
                borderBottom: `1px solid ${palette.greys[600]}`,
            },

            '&:disabled': {
                pointerEvents: 'none',
                color: palette.greys[400],
                borderBottom: `1px solid ${palette.greys[400]}`,
            },
        },
        surroundings: {
            display: 'flex',
            alignItems: 'center',
            flexGrow: 0,
            flexShrink: 0,
            '&:first-child': { marginLeft: -1 },
            '&:last-child': { marginRight: -1 },
        },
        text: {
            textAlign: 'center',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            flexGrow: 1,
        },
        small: {
            ...typography.t71,
            lineHeight: 1,
        },
    }),
    { classNamePrefix: 'TextButton' }
);

type ButtonProps = JSX.IntrinsicElements['button'] & {
    size?: 'small';
    before?: React.ReactNode;
    after?: React.ReactNode;
};

export default TextButton;
